import axios from 'axios';
import { ProposalInput } from '../../../pages/proposal/form/input.interface';
import { getApiInstance } from '../api';

export const createProposal = async ({
  token,
  userInput,
}: {
  token: string;
  userInput: Omit<ProposalInput, 'files'>;
}) => {
  const api = getApiInstance(token);
  try {
    const { data } = await api.post('/proposals', userInput);

    return { success: true, data };
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.status) {
      if (error.response?.status === 400) {
        const apiMessage = error?.response?.data?.message;
        const arrayOfMessages =
          typeof apiMessage === 'string' ? [apiMessage] : apiMessage || [];
        const message = ['Erro ao criar proposta.', ...arrayOfMessages].join(
          ' ',
        );
        return {
          success: false,
          message,
        };
      }
      return {
        success: false,
        message: `Erro ao criar proposta. ${error.response?.data.message}`,
      };
    }

    return {
      success: false,
      message: `Erro ao criar proposta. Erro desconhecido: ${
        (error as Error).message
      }`,
    };
  }
};
